var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForbiddenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 240,
    viewBox: "0 0 337 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23426 147.5C11.3456 179.278 34.9628 207.664 67.5998 208.558C98.3162 209.403 125.855 189.201 156.17 186.155C187.962 182.966 211.082 197.169 233.827 216.789C253.44 233.698 278.014 249.579 303.131 230.347C330.362 209.495 338.144 168.692 335.741 136.946C333.37 105.638 320.107 76.8427 298.949 54.873C256.78 11.0842 186.607 -9.96108 125.925 4.56431C63.1944 19.5804 1.42615 78.2104 8.23426 147.5Z",
    fill: "#F2F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 142.267V165.481H85.7143V187.803H58.9286V165.481H0V138.696L54.4643 62.8027H85.7143V142.267H100ZM58.9286 94.0527L25 142.267H58.9286V94.0527Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M305.619 121.241C309.797 122.784 313.497 124.981 316.72 127.83C319.465 130.205 322.032 133.41 324.419 137.447C326.806 141.364 328 146.351 328 152.405C328 157.273 326.926 161.963 324.777 166.474C322.629 170.985 319.525 174.963 315.467 178.405C311.528 181.848 306.693 184.638 300.964 186.775C295.234 188.794 288.729 189.803 281.448 189.803C273.331 189.803 266.288 188.794 260.32 186.775C254.471 184.757 249.577 182.501 245.638 180.008C240.983 177.159 237.103 173.894 234 170.214L250.114 153.296C252.263 155.789 254.77 158.045 257.634 160.063C260.022 161.725 263.006 163.268 266.587 164.693C270.168 165.999 274.226 166.652 278.762 166.652C285.924 166.652 291.295 165.109 294.876 162.022C298.457 158.935 300.248 155.136 300.248 150.625C300.248 146.113 298.517 142.314 295.055 139.227C291.594 136.141 286.461 134.597 279.657 134.597H266.229V112.337H278.762C284.133 112.337 288.311 110.972 291.295 108.241C294.279 105.392 295.771 101.711 295.771 97.2C295.771 93.1635 294.279 89.7799 291.295 87.0493C288.311 84.3187 284.133 82.9534 278.762 82.9534C274.942 82.9534 271.54 83.6064 268.556 84.9123C265.572 86.0995 263.065 87.4055 261.036 88.8301C258.649 90.4922 256.5 92.3918 254.59 94.5288L238.476 78.5014C241.341 75.0584 244.803 71.9717 248.861 69.2411C252.323 66.8667 256.739 64.7297 262.11 62.8301C267.482 60.8119 273.928 59.8027 281.448 59.8027C287.893 59.8027 293.683 60.7525 298.815 62.652C304.067 64.4329 308.484 66.926 312.065 70.1315C315.765 73.2183 318.57 76.8986 320.48 81.1726C322.509 85.3279 323.524 89.7799 323.524 94.5288C323.524 99.5151 322.569 103.67 320.659 106.995C318.869 110.319 316.839 113.049 314.571 115.186C311.945 117.679 308.961 119.698 305.619 121.241Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.482 36.893C210.017 36.7019 208.743 37.7847 208.616 39.186C208.425 40.651 209.507 41.9249 210.909 42.0523C212.374 42.2434 213.648 41.1606 213.775 39.7593C213.966 38.358 212.947 37.0841 211.482 36.893Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.669 40.7771L251.93 40.4587C251.866 39.5669 251.739 38.6752 251.548 37.8472L254.032 36.7643C254.733 36.4459 254.987 35.6815 254.733 35.0446L254.35 34.1528C254.032 33.4522 253.268 33.1974 252.631 33.4522L250.147 34.535C249.701 33.7707 249.127 33.07 248.49 32.4968L250.147 30.2674C250.592 29.6942 250.465 28.8661 249.892 28.4203L249.064 27.847C248.49 27.4012 247.662 27.5285 247.217 28.1018L245.56 30.3311C244.796 29.949 243.968 29.5668 243.076 29.3757L243.395 26.6368C243.459 25.9362 242.949 25.2355 242.248 25.1718L241.293 25.0444C240.592 24.9807 239.892 25.4903 239.828 26.1909L239.509 28.9298C238.618 28.9935 237.726 29.1209 236.898 29.312L235.815 26.8279C235.497 26.1273 234.732 25.8725 234.095 26.1273L233.204 26.5094C232.503 26.8279 232.248 27.5922 232.503 28.2292L233.586 30.7133C232.821 31.1592 232.121 31.7324 231.548 32.3694L229.318 30.7133C228.745 30.2674 227.917 30.3948 227.471 30.9681L226.898 31.7961C226.452 32.3694 226.579 33.1974 227.153 33.6433L229.382 35.2994C229 36.0637 228.618 36.8917 228.426 37.7835L225.688 37.465C224.987 37.4013 224.286 37.9109 224.223 38.6115L224.095 39.6306C224.032 40.3313 224.541 41.0319 225.242 41.0956L227.981 41.4141C228.044 42.3058 228.172 43.1976 228.363 44.0256L225.879 45.1084C225.178 45.4269 224.923 46.1912 225.178 46.8282L225.56 47.7199C225.879 48.3569 226.643 48.6753 227.28 48.4206L229.764 47.3377C230.21 48.1021 230.783 48.8027 231.42 49.376L229.764 51.6053C229.318 52.1786 229.446 53.0066 230.019 53.4525L230.783 54.0257C231.356 54.4716 232.184 54.3442 232.63 53.7709L234.286 51.5416C235.051 51.9238 235.879 52.306 236.771 52.497L236.452 55.2359C236.388 55.9366 236.898 56.6372 237.599 56.7009L238.554 56.8283C239.255 56.892 239.955 56.3824 240.019 55.6818L240.337 52.9429C241.229 52.8792 242.121 52.7518 242.949 52.5607L244.032 55.0448C244.35 55.7455 245.115 56.0003 245.752 55.7455L246.643 55.3633C247.344 55.0448 247.599 54.2805 247.344 53.6436L246.261 51.1594C247.025 50.7136 247.726 50.1403 248.299 49.5034L250.529 51.1594C251.102 51.6053 251.93 51.4779 252.376 50.9047L252.949 50.0766C253.395 49.5034 253.268 48.6753 252.694 48.2295L250.465 46.5734C250.847 45.8091 251.229 44.981 251.42 44.0893L254.159 44.4078C254.86 44.4715 255.561 43.9619 255.624 43.2612L255.752 42.3058C255.943 41.5415 255.37 40.9045 254.669 40.7771ZM247.471 41.7963C247.025 46.0001 243.267 48.9938 239.064 48.5479C234.86 48.1021 231.866 44.3441 232.376 40.1402C232.821 35.9363 236.579 32.9426 240.783 33.4522C244.924 33.8981 247.917 37.6561 247.471 41.7963Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240.338 37.019C238.172 36.7642 236.198 38.3566 235.943 40.5222C235.688 42.6878 237.28 44.6624 239.446 44.9172C241.612 45.172 243.586 43.5796 243.841 41.4139C244.096 39.2483 242.567 37.2738 240.338 37.019Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.898 206.218L109.956 205.992C109.911 205.36 109.821 204.728 109.685 204.141L111.447 203.373C111.943 203.148 112.124 202.606 111.943 202.154L111.672 201.522C111.447 201.025 110.905 200.845 110.453 201.025L108.692 201.793C108.376 201.251 107.969 200.754 107.518 200.348L108.692 198.767C109.008 198.361 108.918 197.774 108.511 197.458L107.924 197.051C107.518 196.735 106.931 196.825 106.615 197.232L105.441 198.812C104.899 198.541 104.312 198.271 103.679 198.135L103.905 196.193C103.95 195.697 103.589 195.2 103.092 195.155L102.415 195.064C101.918 195.019 101.422 195.38 101.376 195.877L101.151 197.819C100.518 197.864 99.8863 197.954 99.2992 198.09L98.5315 196.329C98.3057 195.832 97.7639 195.651 97.3123 195.832L96.6801 196.103C96.1833 196.329 96.0027 196.871 96.1833 197.322L96.951 199.083C96.4091 199.399 95.9124 199.806 95.506 200.257L93.9255 199.083C93.5191 198.767 92.932 198.858 92.6159 199.264L92.2095 199.851C91.8934 200.257 91.9837 200.845 92.3901 201.161L93.9706 202.335C93.6997 202.877 93.4287 203.464 93.2933 204.096L91.3515 203.87C90.8548 203.825 90.358 204.186 90.3129 204.683L90.2226 205.405C90.1774 205.902 90.5387 206.399 91.0354 206.444L92.9772 206.67C93.0223 207.302 93.1126 207.934 93.2481 208.521L91.487 209.289C90.9902 209.515 90.8096 210.057 90.9902 210.508L91.2612 211.14C91.487 211.592 92.0289 211.818 92.4804 211.637L94.2416 210.869C94.5577 211.411 94.9641 211.908 95.4157 212.314L94.2416 213.895C93.9255 214.301 94.0158 214.888 94.4222 215.205L94.9641 215.611C95.3705 215.927 95.9576 215.837 96.2737 215.43L97.4477 213.85C97.9896 214.121 98.5767 214.392 99.2089 214.527L98.9831 216.469C98.9379 216.966 99.2992 217.462 99.7959 217.508L100.473 217.598C100.97 217.643 101.467 217.282 101.512 216.785L101.738 214.843C102.37 214.798 103.002 214.708 103.589 214.572L104.357 216.334C104.583 216.83 105.125 217.011 105.576 216.83L106.208 216.559C106.705 216.334 106.886 215.792 106.705 215.34L105.937 213.579C106.479 213.263 106.976 212.856 107.382 212.405L108.963 213.579C109.369 213.895 109.956 213.805 110.272 213.398L110.679 212.811C110.995 212.405 110.905 211.818 110.498 211.502L108.918 210.328C109.189 209.786 109.46 209.199 109.595 208.566L111.537 208.792C112.034 208.837 112.53 208.476 112.575 207.979L112.666 207.302C112.801 206.76 112.395 206.263 111.898 206.218ZM106.795 206.941C106.479 209.921 103.815 212.044 100.835 211.682C97.8542 211.366 95.7318 208.702 96.093 205.722C96.4091 202.741 99.0734 200.619 102.054 200.98C104.989 201.296 107.111 203.96 106.795 206.941Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.738 203.554C100.203 203.374 98.8031 204.502 98.6225 206.038C98.4419 207.573 99.5708 208.973 101.106 209.154C102.642 209.334 104.041 208.205 104.222 206.67C104.403 205.09 103.319 203.735 101.738 203.554Z",
    fill: "url(#paint6_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6154 192.4L89.7253 192.084C89.6802 191.136 89.5447 190.187 89.3189 189.284L91.9832 188.11C92.7057 187.794 93.0218 186.981 92.7057 186.259L92.2993 185.31C91.9832 184.588 91.1704 184.272 90.4479 184.588L87.7836 185.762C87.2868 184.949 86.6998 184.226 86.0224 183.549L87.7384 181.201C88.19 180.569 88.0545 179.711 87.4223 179.214L86.5643 178.582C85.9321 178.13 85.0741 178.266 84.5774 178.898L82.8614 181.246C82.0486 180.84 81.1454 180.478 80.2423 180.207L80.5584 177.317C80.6487 176.55 80.1068 175.872 79.3391 175.782L78.3005 175.647C77.5328 175.556 76.8103 176.098 76.7652 176.866L76.4491 179.756C75.5008 179.801 74.5525 179.937 73.6493 180.162L72.4752 177.498C72.1591 176.775 71.3463 176.459 70.6238 176.775L69.6755 177.182C68.9529 177.498 68.6368 178.311 68.9529 179.033L70.127 181.698C69.3142 182.194 68.5917 182.781 67.9143 183.459L65.5661 181.743C64.9339 181.291 64.0759 181.427 63.5792 182.059L62.947 182.917C62.4954 183.549 62.6309 184.407 63.2631 184.904L65.6113 186.62C65.1597 187.433 64.8436 188.336 64.5727 189.239L61.6826 188.923C60.9149 188.833 60.2376 189.374 60.1472 190.142L60.0118 191.181C59.9215 191.948 60.4633 192.671 61.2762 192.716L64.1662 193.032C64.2114 193.98 64.3469 194.929 64.5727 195.832L61.9084 197.006C61.1859 197.322 60.8698 198.135 61.1859 198.857L61.5923 199.806C61.9084 200.528 62.7212 200.844 63.4437 200.528L66.108 199.354C66.6047 200.167 67.1918 200.89 67.8692 201.567L66.1532 203.915C65.7016 204.547 65.8371 205.405 66.4693 205.902L67.3273 206.534C67.9595 206.986 68.8175 206.85 69.3142 206.218L71.0302 203.87C71.843 204.322 72.7462 204.638 73.6493 204.909L73.3332 207.799C73.2429 208.566 73.7848 209.289 74.5525 209.379L75.5911 209.515C76.3587 209.605 77.0361 209.063 77.1264 208.295L77.4425 205.405C78.3908 205.36 79.3391 205.225 80.2423 204.999L81.4164 207.663C81.7325 208.386 82.5453 208.702 83.2678 208.386L84.2161 207.979C84.9387 207.663 85.2548 206.85 84.9387 206.128L83.7646 203.464C84.5774 202.967 85.2999 202.38 85.9773 201.702L88.3255 203.418C88.9577 203.87 89.8157 203.734 90.3124 203.102L90.9446 202.244C91.3962 201.612 91.2607 200.754 90.6285 200.257L88.2803 198.541C88.7319 197.729 89.048 196.825 89.3189 195.922L92.209 196.238C92.9767 196.329 93.6992 195.787 93.7444 195.019L93.8798 193.98C93.925 193.213 93.3831 192.49 92.6154 192.4ZM84.9387 193.484C84.4419 197.909 80.4229 201.115 75.9975 200.619C71.5721 200.122 68.3659 196.103 68.8626 191.677C69.3594 187.252 73.3784 184.046 77.8038 184.543C82.2744 185.039 85.4354 189.058 84.9387 193.484Z",
    fill: "url(#paint7_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3968 188.423C75.0938 188.152 72.9714 189.823 72.7456 192.126C72.4747 194.429 74.1455 196.552 76.4485 196.777C78.7515 197.048 80.8739 195.378 81.0997 193.075C81.3707 190.772 79.6999 188.649 77.3968 188.423Z",
    fill: "url(#paint8_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.017 189.188C207.305 189.188 237.534 158.96 237.534 121.671C237.534 84.3826 207.305 54.1543 170.017 54.1543C132.728 54.1543 102.5 84.3826 102.5 121.671C102.5 158.96 132.728 189.188 170.017 189.188Z",
    fill: "url(#paint9_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218 106.803H122V136.803H218V106.803Z",
    fill: "url(#paint10_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.735 91.4151C93.7098 91.4151 87.2129 85.0456 87.2129 77.2111C87.2129 69.3766 93.7098 62.9434 101.735 62.9434C102.882 62.9434 104.092 63.0708 105.175 63.3255L106.258 63.5803L106.321 62.5612C107.404 52.37 116.003 44.7266 126.385 44.7266C134.347 44.7266 141.609 49.3126 144.793 56.5102L145.048 57.0197L145.621 57.0834C150.781 57.4019 155.239 60.8414 156.832 65.6186L157.15 66.574L158.106 66.1918C159.698 65.5549 161.354 65.2364 163.074 65.2364C170.399 65.2364 176.386 71.0963 176.386 78.2939C176.386 85.3004 170.845 91.0329 163.711 91.3514H163.329H101.735V91.4151Z",
    fill: "url(#paint11_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M211.228 192.372C204.285 192.372 198.68 186.83 198.68 180.015C198.68 173.2 204.285 167.658 211.228 167.658C212.247 167.658 213.266 167.786 214.221 168.04L215.304 168.295L215.431 167.212C216.323 158.422 223.839 151.734 232.82 151.734C239.699 151.734 246.005 155.747 248.808 161.926L249.063 162.435L249.636 162.499C254.094 162.754 257.98 165.747 259.317 169.887L259.636 170.843L260.591 170.461C261.929 169.951 263.394 169.633 264.859 169.633C271.228 169.633 276.388 174.728 276.388 180.97C276.388 187.021 271.547 191.99 265.432 192.308H265.114H211.228V192.372Z",
    fill: "url(#paint12_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: 81.2129,
    y: 38.7266,
    width: 101.173,
    height: 58.6885,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b",
    x: 192.68,
    y: 145.734,
    width: 89.7081,
    height: 52.6375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.91228,
    y1: 108.721,
    x2: 108.417,
    y2: 165.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#002295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 238.572,
    y1: 108.266,
    x2: 341.84,
    y2: 160.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#002295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 208.595,
    y1: 39.4714,
    x2: 213.797,
    y2: 39.4714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 224.1,
    y1: 40.9288,
    x2: 255.78,
    y2: 40.9288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 235.919,
    y1: 40.9662,
    x2: 243.867,
    y2: 40.9662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 90.2259,
    y1: 206.326,
    x2: 112.686,
    y2: 206.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 98.6053,
    y1: 206.353,
    x2: 104.24,
    y2: 206.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 60.0127,
    y1: 192.573,
    x2: 93.8735,
    y2: 192.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 72.7195,
    y1: 192.598,
    x2: 81.1263,
    y2: 192.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 187.215,
    y1: 163.2,
    x2: 135.621,
    y2: 78.4853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.252412,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#4567DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 122.031,
    y1: 121.796,
    x2: 217.975,
    y2: 121.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 131.799,
    y1: 44.7266,
    x2: 131.799,
    y2: 91.4151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0916665,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398958,
    stopColor: "white",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669792,
    stopColor: "#F6F9FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 237.534,
    y1: 151.734,
    x2: 237.534,
    y2: 192.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708332,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "white",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F9FB",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbiddenIcon);
export default __webpack_public_path__ + "static/media/ForbiddenIcon.741a9c3c.svg";
export { ForwardRef as ReactComponent };